<div class="row m-0 h-100">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 LoginBg setPadding ">
    <div class="row m-0 h-100 login">
      <div class="row_tab sections ">
        <div class="head">
        <app-header></app-header>
      </div>
        <div class="row">
          <!-- <span [routerLink]='[""]'>
          <img src="assets/images/logout (1).png">
          <p class="firp" >Logout</p>
          </span>
          <span>
          <img src="assets/images/left-arrow.png">
          <p>Dashboard</p>
          </span> -->
        </div>
      </div>
      <div class="container">
        <div class="row">
            <div class="col-sm-6 ">
                <mat-card class="singlecard">
                  <div>
                    <h3>User Details</h3>
                  </div>
                  <div>
                    <p>User Name</p>
                    <p>{{userData.userData.firstname}} {{userData.userData.lastname}}</p>
                  </div>
                  <div>
                    <p>Email</p>
                    <p>{{userData.userData.email}}</p>
                  </div>
                  <div>
                    <p>Phone Number</p>
                    <p>{{userData.userData.phone}}</p>
                  </div>
                  <div>
                    <p>Address</p>
                    <p>{{userData.userData.bt_address.street_number}}, {{userData.userData.bt_address.address1}},
                      {{userData.userData.bt_address.bt_zipcode.city}},
                      {{userData.userData.bt_address.bt_zipcode.bt_region.name}},
                      {{userData.userData.bt_address.bt_zipcode.city}},
                      {{userData.userData.bt_address.bt_zipcode.bt_region.bt_country.name}}</p>
                  </div>
                </mat-card>
              </div>
          <div class="col-sm-6 ">
            <mat-card class="singlecard">
                <div>
                    <h3>Business Details</h3>
                  </div>
              <div>
                <p>Business Name</p>
                <p>{{userData.userData.bp_businesses[0].name}}</p>
              </div>
              <div>
                <p>DBA</p>
                <p>{{userData.userData.bp_businesses[0].dba}}</p>
              </div>
              <div>
                <p>Nickname</p>
                <p>{{userData.userData.bp_businesses[0].nickname}}</p>
              </div>
              <div>
                <p>Fed Tax ID/EIN</p>
                <p>{{userData.userData.bp_businesses[0].fed_taxid}}</p>
              </div>
              <div>
                <p>Website URL</p>
                <p>{{userData.userData.bp_businesses[0].web_url}}</p>
              </div>
              <div>
                <p>Entity Type</p>
               <p>{{entit}}</p> 
              </div>
              <div>
                <p>Address</p>
                <p>{{userData.userData.bp_businesses[0].bt_address.street_number}} ,
                  {{userData.userData.bp_businesses[0].bt_address.address1}},{{userData.userData.bp_businesses[0].bt_address.bt_zipcode.city}},
                  ,{{userData.userData.bp_businesses[0].bt_address.bt_zipcode.county}},
                  {{userData.userData.bp_businesses[0].bt_address.bt_zipcode.bt_region.bt_country.name}}
                </p>
              </div>
            </mat-card>
          </div>

          <div class="col-sm-6 ">
            <mat-card class="singlecard">
                <div>
                    <h3>Cannabis Related Details</h3>
                  </div>
              <div>
                <p>Cannabis Business Type</p>
                <p>{{licensetype}}</p>
              </div>
              <div>
                <p>Cannabis Licensed State/Province</p>
                <p>{{state}}</p>
              </div>
              <div>
                <p>Cannabis License Number</p>
                <p>{{userData.userData.bp_businesses[0].bp_license_no}}</p>
              </div>
              <div>
                <p>Cannabis License Expiration Date</p>
                <p>{{userData.userData.bp_businesses[0].bp_license_no_expiration| date }}</p>
              </div>
              <div>
                <p>Cannabis Tax ID</p>
                <p>{{userData.userData.bp_businesses[0].cannabistaxid }}</p>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
      <div class="register">
        <!-- <p>Already a User in StandardC ? </p>
        <p><a [routerLink]="['/']"> Login</a></p> -->
      </div>
      <div class="col-12">
        <app-footer></app-footer>
  
          </div>
    </div>
  </div>
</div>